import { apiClientBff } from './apiBff';

class TitleGenerationService {
  // Agora sempre usamos o BFF; não expomos tokens no frontend
  async generateTitle(sessionId: string, question?: string): Promise<string> {
    try {
      const payload = {
        sessionId,
        question: question || '',
      };

      const response = await apiClientBff.post<any>('/title/generate', payload);

      let title = 'Nova Conversa';

      if (response) {
        // Resposta do BFF pode ser { success, title, fallback } ou { success, data }
        if (response.success && typeof response.title === 'string') {
          title = response.title;
        } else if (response.success && response.data) {
          const data = response.data;
          if (typeof data.title === 'string') {
            title = data.title;
          } else if (typeof data.text === 'string') {
            try {
              const parsed = JSON.parse(data.text);
              if (parsed && typeof parsed.title === 'string') {
                title = parsed.title;
              }
            } catch (e) {
              console.warn('Failed to parse title from Flowise text field:', e);
            }
          } else if (typeof data === 'string') {
            try {
              const parsed = JSON.parse(data);
              if (parsed && typeof parsed.title === 'string') {
                title = parsed.title;
              }
            } catch (e) {
              console.warn('Failed to parse title from Flowise string body:', e);
            }
          }
        }

        // Se ainda não extraímos, gerar um fallback curto com base na pergunta
        if (!title || title === 'Nova Conversa') {
          const input = question || '';
          title = input.length > 50 ? input.slice(0, 47) + '...' : (input || 'Nova Conversa');
        }
      }

      return title;
    } catch (error) {
      console.error('Error generating title:', error);
      return 'Nova Conversa';
    }
  }

  // Consideramos o serviço sempre configurado quando o BFF está acessível
  isConfigured(): boolean {
    return true;
  }
}

export const titleGenerationService = new TitleGenerationService();
export default titleGenerationService;